<template>
  <v-main>
    <PageWrapper>
      <PageContent>
          <div class="menu">
            <!--<Card v-for="item in items"
              :key="item"
              :nome="item.nome"
              :icon="item.icon"
              :path="item.path"
            >
            </Card>
            -->
            <v-row align="center" justify="center">
              <v-img src="@/assets/images/mk-logo.png" max-width="500"></v-img>
            </v-row>
          </div>
      </PageContent>
    </PageWrapper>
  </v-main>
</template>

<script>
import PageWrapper from '@/components/template/PageWrapper.vue';
import PageContent from '@/components/template/PageContent.vue';
export default {
  components:{
    PageWrapper,
    PageContent,
  },
  data () {
    return {
      items: [
        {nome:"Cadastro de pessoas", icon:"mdi-account", path:'/cadastrodepessoas'},
        {nome:"Cadastro de Unidades",  icon:"mdi-forklift", path:'/cadastrodeobras'},
        {nome:"Cadastro de Empresas", icon:"mdi-clipboard-outline", path:'/cadastrodeempresas'},
        {nome:"Cadastro de boletos", icon:"mdi-ticket-outline", path:'/cadastrodepessoas'},
        {nome:"Cadastro de Entrada", icon:"mdi-content-duplicate", path:'/entrada'},
        {nome:"Cadastro de Saída", icon:"mdi-exit-to-app", path:'/saida'},
      ],
    }
  }
}
</script>

<style scoped>
.container{
  height: 100%
}
.alert{
  display: flex;
  flex-direction: column;
}
.menu{
  padding-top: 20px !important;
  display: flex;
  flex-wrap: wrap;
  height: 80vh
}
</style>

